module.exports = __webpack_public_path__ + "static/media/privacy_statement_hu.42a53aa0.pdf";